import {ACTION_TYPE_ADD} from './constants'

const addVariation = function (key, value) {
  return {
    type: ACTION_TYPE_ADD,
    key,
    value,
  }
}

const fetchVariation = async function (dispatch, key) {
  const variable = await Drupal?.behaviors?.kontoroLab.getVariationName(key)
  dispatch(addVariation(key, variable))
  return variable
}

export default {
  addVariation,
  fetchVariation: (key) => (dispatch) => fetchVariation(dispatch, key),
}
